import { environment } from '../../../environments/environment';

export const apiConstants = {
  baseUrl: environment.baseUrl,
  baseUrlAuth: environment.baseUrl + environment.baseUrlAuth,
  baseUrlPortal: environment.baseUrl + environment.baseUrlPortal,
  publicEndpoints: {
    generateOTP: 'YXV0aC9nZW5lcmF0ZS1vdHA/dHlwZUlkPQ==',
    verifyOTP: 'YXV0aC92ZXJpZnktb3Rw',
    signUp: 'YXV0aC9zaWdudXA='
  },
  privateEndpoints: {
    userUpdate: 'dXNlci91cGRhdGU=',
    lookups: 'dXNlci9sb29rdXBz',
    user: 'dXNlcg==',
    session: 'YXV0aC9zZXNzaW9u',
    logout: 'YXV0aC9sb2dvdXQ=',
    updateLanguage: 'dXNlci91cGRhdGUtbGFuZ3VhZ2U=',
    refreshToken: 'YXV0aC9yZWZyZXNo',
    file: 'ZmlsZQ==',
    getCme: 'Y21l',
    ddls: 'Y21lL2RkbHM=',
    cmeDelete: 'Y21lL2RlbGV0ZQ==',
    cmeUpdate: 'Y21lL3VwZGF0ZQ==',
    profile: 'cHJvZmlsZQ==',
    ddlsProfile: 'cHJvZmlsZS9kZGxz',
    credit: 'Y21lL2NyZWRpdHM=',
    creditCategory: 'ZGFzaGJvYXJkL2NtZS1jcmVkaXQtYnktcmVzb3VyY2U/bW9udGg9',
    creditHistory: 'ZGFzaGJvYXJkL2NtZS1jcmVkaXRzLWhpc3Rvcnkv',
    axonifySso: 'ZGFzaGJvYXJkL2F4b25pZnktc3NvLXYy',
    axonifySSO: 'ZGFzaGJvYXJkL2F4b25pZnktc3Nv',
    downloadAttachment: 'Y21lL2Rvd25sb2FkLWNtZS1yZWNvcmQ=',
    exportCME: 'Y21lL2V4cG9ydC1jbWUtcmVwb3J0',
    eventTiles: 'ZXZlbnQvdGlsZXM=',
    event: 'ZXZlbnQ=',
    rsvp: 'ZXZlbnQvcnN2cA==',
    sync: 'cHJvZmlsZS9zeW5j',
    faceRegister: 'ZmFjZS9yZWdpc3Rlcg==',
    faceVerify: 'ZmFjZS92ZXJpZnk=',
    searchDocument: 'a25vd2xlZGdlLWh1Yi9kb2N1bWVudHMKCg==',
    getDocument: 'a25vd2xlZGdlLWh1Yi9kb2N1bWVudHM=',
    downloadDocument: 'a25vd2xlZGdlLWh1Yi9kb3dubG9hZA==',
    folderContent: 'a25vd2xlZGdlLWh1Yi9mb2xkZXJz',
    recommendation: 'cmVjb21tZW5kYXRpb24=',
    unifiedSearch: 'ZGFzaGJvYXJkL3VuaWZpZWQtc2VhcmNo'
  }
};
